import React from 'react'
import Text from '../../components/text/Text'
import WizButton from '../../components/button/WizButton'
import {ICaseVariable} from './types'

interface IProps {
    open: boolean
    onClose: () => void
    variables: ICaseVariable[] // live /kinds 계약에서 파생한 전체 변수 정의
}

const VariableGuideModal: React.FC<IProps> = ({open, onClose, variables}) => {
    if (!open) return null
    return (
        <div className={'fixed inset-0 z-modal flex items-center justify-center'}>
            <div className={'absolute inset-0 bg-black/50'} onClick={onClose} />
            <div className={'relative z-10 w-[90%] max-w-[560px] bg-white rounded-[8px] p-[24px] shadow-hover'}>
                <Text className={'text-h3 text-font01'}>변수 목록</Text>
                <Text className={'text-ti3 text-font03 mt-[6px]'}>
                    아래 변수명을 문구에 넣으면 실제 데이터로 치환됩니다.
                </Text>

                <div className={'mt-[16px] border border-line02 rounded-[8px] overflow-hidden max-h-[60vh] overflow-y-auto'}>
                    <div className={'grid grid-cols-[240px_1fr] bg-line02 px-[16px] py-[10px]'}>
                        <Text className={'text-ti3 font-bold text-font01'}>변수명 (Token)</Text>
                        <Text className={'text-ti3 font-bold text-font01'}>데이터 정의</Text>
                    </div>
                    {variables.map(variable => (
                        <div key={variable.name} className={'grid grid-cols-[240px_1fr] px-[16px] py-[10px] border-t border-line02'}>
                            <Text className={'text-body2 font-bold text-sub_blue'}>{`{${variable.name}}`}</Text>
                            <Text className={'text-body2 text-font02'}>{variable.description}</Text>
                        </div>
                    ))}
                </div>

                <div className={'mt-[24px] flex justify-end'}>
                    <WizButton text={'닫기'} onClick={onClose} />
                </div>
            </div>
        </div>
    )
}

export default VariableGuideModal
